// File: client/src/App.js
// Minimal router for FemaleUTI — only 4 public routes.

import React, { useEffect, Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';

import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import ScrollToTop from './components/common/ScrollToTop';
import { captureAttribution } from './hooks/useAttribution';

const Home = React.lazy(() => import('./pages/Home'));
const BookConsultation = React.lazy(() => import('./pages/BookConsultation'));
const BookingSuccess = React.lazy(() => import('./pages/BookingSuccess'));
const Privacy = React.lazy(() => import('./pages/Privacy'));
const Terms = React.lazy(() => import('./pages/Terms'));

const PageLoader = () => (
  <div className="min-h-screen flex items-center justify-center bg-pink-gradient">
    <div className="text-center">
      <div className="inline-block w-10 h-10 border-4 border-primary-200 border-t-primary-600 rounded-full animate-spin" />
      <p className="mt-4 text-sm text-primary-700 font-medium">Loading…</p>
    </div>
  </div>
);

function App() {
  useEffect(() => {
    captureAttribution();
  }, []);

  return (
    <HelmetProvider>
      <Router>
        <ScrollToTop />
        <div className="flex flex-col min-h-screen bg-white">
          <Header />
          <main className="flex-1">
            <Suspense fallback={<PageLoader />}>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/book-consultation" element={<BookConsultation />} />
                <Route path="/booking-success" element={<BookingSuccess />} />
                <Route path="/privacy" element={<Privacy />} />
                <Route path="/terms" element={<Terms />} />
                {/* Catch-all → home */}
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </Suspense>
          </main>
          <Footer />
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;
